<tec-modal
	[isVisible]="true"
	[title]="'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.TITLE' | translate"
	[tagImage]="modalTagImage"
	[buttonPrimaryLabel]="primaryLabelKey | translate"
	[buttonSecondaryLabel]="
		isContinueMode ? ('WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.EDIT_FORM' | translate) : undefined
	"
	(closeEvent)="closeModal($event)"
>
	<ng-container body [formGroup]="form">
		<div class="form-ocr-order-modal__body">
			<tec-alert
				status="default"
				type="message"
				icon="icon-info"
				hiddenCloseButton
				[msg]="'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.ALERT' | translate"
			/>

			<div class="body__text">
				<span>{{ 'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.HINT' | translate }}</span>
			</div>

			<div class="grid grid-i2">
				<tec-card-select
					[tagImg]="{ icon: 'icon-AI', status: 'control' }"
					[title]="'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.DOCUMENT_TITLE' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.DOCUMENT_DESCRIPTION' | translate"
					[selected]="isChoiceSelected('document')"
					(selectedChange)="selectChoice('document', $event)"
				/>
				<tec-card-select
					[tagImg]="{ icon: 'icon-fill-form', status: 'level' }"
					[title]="'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.MANUAL_TITLE' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.MANUAL_DESCRIPTION' | translate"
					[selected]="isChoiceSelected('manual')"
					(selectedChange)="selectChoice('manual', $event)"
				/>
			</div>
		</div>
	</ng-container>
</tec-modal>
